import WireCard from "./WireCard";

export default WireCard;